export default "__VITE_ASSET__BvG5LumV__"